export const apiEndpoints = [
  {
    label: "Europe",
    value: [
      "eu-west-1", // Ireland
      "eu-west-2", // London
      "eu-west-3", // Paris
      "eu-central-1", // Frankfurt
      "eu-central-2", // Zurich
      "eu-south-1", // Milan
      "eu-south-2", // Spain
      "eu-north-1" // Stockholm
    ],
    default: true,
    url: "https://sellercentral.amazon.co.uk/apps/authorize/consent"
  },
  {
    label: "North America",
    value: [
      "us-east-1", // N. Virginia (US)
      "us-west-1", // N. California
      "us-west-2", // Oregon
      "us-east-2", // Ohio
      "ca-central-1" // Canada
    ],
    url: "https://sellercentral.amazon.com/apps/authorize/consent"
  },
  {
    label: "South America",
    value: [
      "sa-east-1" // São Paulo
    ],
    url: "https://sellercentral.amazon.com.br/apps/authorize/consent"
  },
  {
    label: "Far East",
    value: [
      "ap-northeast-1", // Tokyo
      "ap-northeast-2", // Seoul
      "ap-northeast-3", // Osaka
      "ap-south-1", // Mumbai
      "ap-south-2", // Hyderabad
      "ap-southeast-1", // Singapore
      "ap-southeast-2", // Sydney
      "ap-southeast-3", // Jakarta
      "ap-southeast-4", // Melbourne
      "ap-east-1" // Hong Kong
    ],
    url: "https://sellercentral.amazon.co.jp/apps/authorize/consent"
  },
  {
    label: "Middle East & Africa",
    value: [
      "me-south-1", // Bahrain
      "me-central-1", // UAE
      "af-south-1" // South Africa
    ],
    url: "https://sellercentral.amazon.ae/apps/authorize/consent"
  }
];

export function getAuthorizeUrlByRegion(region) {
  const endpoint =
    apiEndpoints.find(group => group.value.includes(region)) ||
    apiEndpoints.find(group => group.default);

  return endpoint?.url ?? null;
}

export const amazonDefaultRegion = apiEndpoints?.find(region => region.default);
